// @flow strict
import React from 'react';
import { Link } from 'gatsby';
import Author from './Author';
import Comments from './Comments';
import Content from './Content';
import Meta from './Meta';
import Tags from './Tags';
import styles from './Post.module.scss';
import type { Node } from '../../types';

type Props = {
  post: Node
};

const Post = ({ post }: Props) => {
  const { html } = post;
  const { tagSlugs, slug } = post.fields;
  const { tags, title, date } = post.frontmatter;

  return (
    <div className={styles['post']}>
      <Link className={styles['post__home-button']} to="/">All Articles</Link>

      <div className={styles['post__content']}>
        <Content body={html} title={title} />
      </div>
      <hr />
      <div className={styles['post__footer']} style={{marginTop: 40}}>
        <p style={{marginBottom:0}}>Lad dir jetzt unsere Packlisten App herunter um bestens vorbereitet zu sein:</p>
        <div style={{display:"flex"}}>
          <a href="https://play.google.com/store/apps/details?id=com.tnx.packed&utm_source=blog_about" ><img src="https://play.google.com/intl/en_us/badges/static/images/badges/de_badge_web_generic.png" loading="lazy" alt="Download Packing List on Google play" width="170" style={{marginTop:7}}/></a>
          <a href="https://apps.apple.com/us/app/packing-list-travel-planner/id1450969243?itsct=apps_box&amp;itscg=30200" style={{display: "inline-block", width: 140, marginLeft:10}}><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-US?size=250x83&amp;releaseDate=1549152000&h=c59a9a110718ef790920785ac6b71371" loading="lazy" alt="Download Packing List on the App Store" style={{borderRadius:13, width:250, height: 83}} /></a>
        </div>

      </div>

      <div className={styles['post__footer']}>
        <Meta date={date} />
        {tags && tagSlugs && <Tags tags={tags} tagSlugs={tagSlugs} />}
        <Author />
      </div>

      <div className={styles['post__comments']}>
        <Comments postSlug={slug} postTitle={post.frontmatter.title} />
      </div>
    </div>
  );
};

export default Post;
